<template>
  <div class="outer-box max-w-xl">
    <h4>Upload Number Pricing</h4>

    <b-alert show variant="info" class="text-left m-3">
      Upload a CSV file to update number pricing information. The API expects a 'file' field in the form-data.
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <input ref="csvFileInput" class="hl_input--wrap mb-3" type="file" @change="handleFileUpload" accept=".csv" />
      <button class="btn btn-primary mt-4" @click="uploadPricingCsv" :disabled="!selectedFile || uploadProcessing">
        <moon-loader v-if="uploadProcessing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Upload CSV </span>
      </button>
      <pre v-if="uploadResponse" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        uploadResponse
      }}</pre>
    </div>
  </div>
</template>

<script>
import { ISVService } from "@/services";

export default {
  data() {
    return {
      selectedFile: null,
      uploadProcessing: false,
      uploadResponse: null,
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.uploadResponse = null;
      } else {
        this.selectedFile = null;
      }
    },

    uploadPricingCsv() {
      if (!this.selectedFile) {
        this.uploadResponse = { message: "Please select a CSV file first." };
        return;
      }

      this.uploadProcessing = true;
      this.uploadResponse = null;
      
      // Create FormData object
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      

      // Call the service method with FormData
      ISVService.uploadNumberPricingCsv(formData)
        .then((response) => {
          this.uploadResponse = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.uploadResponse = error.response.data;
          } else {
            this.uploadResponse = { 
              message: "An unknown error occurred during upload.", 
              error: error.message 
            };
          }
        })
        .finally(() => {
          this.uploadProcessing = false;
          if (this.$refs.csvFileInput) {
            this.$refs.csvFileInput.value = null;
          }
          this.selectedFile = null;
        });
    },
  },
};
</script>

<style></style> 